import { render } from "./CCTikTok.vue?vue&type=template&id=4567b228&scoped=true"
const script = {}

import "./CCTikTok.vue?vue&type=style&index=0&id=4567b228&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4567b228"]])

export default __exports__